// extracted by mini-css-extract-plugin
export default {"container":"P3-z"};